import { Button } from "@/components/elements/Button";
import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { logout } from "@/utils/logout";
import { createUrlWithParams } from "@/utils/url";
import { Paper, Stack, Typography, styled } from "@mui/material";
import { FC } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

type TResetPasswordCompletePageProps = {};

type TResetPasswordCompleteState = {
  resetCompleted?: boolean;
  externalId: string;
  email: string;
};

export const ResetPasswordCompletePage: FC<TResetPasswordCompletePageProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as TResetPasswordCompleteState | null;
  const isResetCompleted = Boolean(state?.resetCompleted);

  const goToLogin = async () => {
    await logout();
    if (!state) {
      navigate(AppRoutes.login);
      return;
    }
    navigate(createUrlWithParams(AppRoutes.loginCredentials, { externalId: state.externalId, email: state.email }));
  };

  if (!isResetCompleted) return <Navigate to={AppRoutes.login} replace />;

  return (
    <Stack gap="50px" alignItems="center">
      <LoginLogo />
      <Container>
        <Stack gap="48px" width={400}>
          <Stack gap={4}>
            <Typography variant="head20Bold" color={text.primary} textAlign="center">
              パスワード再発行完了
            </Typography>
            <Typography variant="body14" color={text.secondary}>
              パスワードの再発行が完了いたしました。
              <br />
              パスワードの再発行完了メールをご登録されているメールアドレス宛に送信いたしました。
            </Typography>
          </Stack>
          <Button type="button" size="sm" variant="primary" fullWidth onClick={goToLogin}>
            ログイン画面へ
          </Button>
        </Stack>
      </Container>
    </Stack>
  );
};

const Container = styled(Paper)`
  border-radius: 12px;
  padding: 24px;
  box-shadow:
    0 4px 4px -1px rgba(12, 12, 13, 0.05),
    0 4px 4px -1px rgba(12, 12, 13, 0.1) !important;
`;
